import React from 'react';
import LeadItem from '../Domain/LeadItem.js';
import dateTimeHelper from '../Helpers/datetimeHelper.js';
import serviceHelper from '../Helpers/serviceHelper.js';
import AuthService from './authService.js';
import SearchParams from '../Elements/SearchParams';
import LeadSearchParams from '../Contents/Sales/LeadAdmin/LeadSearchParams';

class LeadService extends React.Component
{
  static GetLeadList (leadId)
  {
    const authService = AuthService.getInstance();

    let url = '/api/Lead';

    if (leadId != null && leadId !== -1)
    {
      url += `/${leadId}`;
    }
    url += '?clearCache=false';
    return authService.CallBackendFunction(url);
  }

  static leadList = null;
  static prevLeadId = -2;

  static GetLeadListBySearching (orderById, orderDir, pageNumber, numberOfElements, searchItem)
  {
    const searchParams = new SearchParams(searchItem, LeadSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/Lead/GetAllBySearchingAsync/?searchParams=${searchParams.serializeForBackendCall()}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems (itemlist)
  {
    if (itemlist !== null)
    {
      return itemlist.map((item) => new LeadItem(item));
    }
    return [];
  }

  static postLeadImportFile (data)
  {
    const authService = AuthService.getInstance();

    const url = '/api/Lead/PostLeadImportFile/';

    return authService.CallBackendFunctionPostFile(url, data);
  }

  static EditLead (lead)
  {
    lead.CallbackDate = dateTimeHelper.toYYYYsMMsDDsHHsMM(lead.CallbackDate);
    lead.Birthday = dateTimeHelper.toYYYYsMMsDDsHHsMM(lead.Birthday);
    lead = serviceHelper.ConvertAllPropertyToString(lead);
    const leadJSON = JSON.stringify(lead);

    return AuthService.getInstance().CallBackendFunctionPut('/api/Lead/EditLead', leadJSON);
  }

  static ConvertLead (id, messageItem)
  {
    const messageItemJson = JSON.stringify(messageItem);
    return AuthService.getInstance().CallBackendFunctionPut(`/api/Lead/ConvertLead/${id}`, messageItemJson);
  }

  static ExportAdminExcelAsync (searchItem)
  {
    const url = `/api/Lead/ExportAdminExcelAsync?searchItem=${JSON.stringify(searchItem)}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }
}

export default LeadService;
